import { DocumentsController } from 'features/documentos/libs/CorporateController'
import { DocumentNotificationContext } from 'features/documentos/providers/DocumentNotificationsProvider'
import { NotificationsContext } from 'features/notifications/providers/NotificationsProvider'
import { selectMenus } from 'features/portal/menusSlice'
import { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import notifyUnreadedComunicados from './libs/notifyUnreadComunicados'
import notifyUnreadedDocs from './libs/notifyUnreadedDocs'
import { selectUsuario } from 'features/users/stores/userSlice'

const AutomationController = () => {
  const menu = useSelector(selectMenus)
  const user = useSelector(selectUsuario)
  const [launched, setLaunched] = useState(false)
  const { launchModalWithList, forceRefresh: refreshDocumentNotifications } = useContext(
    DocumentNotificationContext,
  )
  const { forceRefresh: refreshNotifications } = useContext(NotificationsContext)

  const navigate = useNavigate()

  const navigateTo = (url) => {
    navigate(url)
  }

  useEffect(() => {
    if (!user) return
    setLaunched(false)
  }, [user])

  useEffect(() => {
    if (menu.length < 2 || launched) return
    refreshNotifications()
    refreshDocumentNotifications()
    if (!launched) {
      setLaunched(true)
      notifyUnreadedDocs(menu, navigateTo)
      notifyUnreadedComunicados(menu, navigateTo)
      DocumentsController.getAllBloqueantes()
        .then((todos) => {
          if (todos && todos.length > 0) launchModalWithList(todos)
        })
        .catch(() => {})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menu, launched])

  return <></>
}

export default AutomationController
